export type LiveEventKind = 'order' | 'assign';

export interface LiveEvent {
  kind: LiveEventKind;
  title: string;
  note: string;
  orderNo: string;
  customer?: string;
  customerPhone?: string;
  items?: string;
  itemsCount?: number;
  priority?: 'normal' | 'urgent';
  amount?: string;
}

export const liveNotificationEvents: LiveEvent[] = [
  {
    kind: 'order',
    title: 'طلب جديد وصل للتو',
    note: 'طلب #98757 من فهد العتيبي بانتظار القبول',
    orderNo: '#98757',
    customer: 'فهد العتيبي',
    customerPhone: '0551112233',
    items: 'قميص × 2، بنطلون × 1',
    itemsCount: 3,
    priority: 'normal',
    amount: '95 ر.س',
  },
  {
    kind: 'assign',
    title: 'يحتاج تعيين مندوب',
    note: 'طلب #98745 انتهت مدة الانتظار ويحتاج تعيين يدوي',
    orderNo: '#98745',
  },
  {
    kind: 'order',
    title: 'طلب جديد وصل للتو',
    note: 'طلب #98758 من نورة القحطاني بانتظار القبول',
    orderNo: '#98758',
    customer: 'نورة القحطاني',
    customerPhone: '0551234567',
    items: 'فستان × 2، عباية × 1',
    itemsCount: 3,
    priority: 'urgent',
    amount: '150 ر.س',
  },
  {
    kind: 'order',
    title: 'طلب جديد وصل للتو',
    note: 'طلب #98759 من بندر الشهري بانتظار القبول',
    orderNo: '#98759',
    customer: 'بندر الشهري',
    customerPhone: '0567890123',
    items: 'ثوب × 3',
    itemsCount: 3,
    priority: 'normal',
    amount: '75 ر.س',
  },
  {
    kind: 'assign',
    title: 'يحتاج تعيين مندوب',
    note: 'طلب #98731 انتهت مدة الانتظار ويحتاج تعيين يدوي',
    orderNo: '#98731',
  },
  {
    kind: 'order',
    title: 'طلب جديد وصل للتو',
    note: 'طلب #98760 من سارة الدوسري بانتظار القبول',
    orderNo: '#98760',
    customer: 'سارة الدوسري',
    customerPhone: '0509876543',
    items: 'مفرش × 1، بدلة × 1',
    itemsCount: 2,
    priority: 'urgent',
    amount: '180 ر.س',
  },
];